<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Civil Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Academic Achievers'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="7"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Academic Achievers</div>
          <tab-view class="">
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2020-21</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2020-21')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2019-20</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2019-20')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2018-19</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2018-19')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2017-18</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2017-18')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2016-17</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2016-17')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2015-16</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2015-16')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/civil/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AchieverComponent from "@/components/AchieverComponent";

export default {
  name: "landing-page",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel,
    AchieverComponent
  },
  data() {
    return {
      results: [
        {
          year: '2020-21',
          students: [
            {
              name: 'Miss. Rokade Shubhangi Valmik',
              image: '/static/images/civil/academicAchievers/2020-21/rokade_shubhangi.jpg',
              score: 'CGPA - 8.86'
            },
            {
              name: 'Miss. Pokale Apeksha Sunil',
              image: '/static/images/civil/academicAchievers/2020-21/pokale_apeksha.jpg',
              score: ' CGPA - 8.77'
            },
            {
              name: 'Mr. Dagadu Sadashiv Kadalkar',
              image: '/static/images/civil/academicAchievers/2020-21/dagadu_sadashiv.jpg',
              score: 'CGPA - 8.57'
            }
          ]
        },
        {
          year: '2019-20',
          students: [
            {
              name: 'Miss. Jadhav Swati Kiran',
              image: '/static/images/civil/academicAchievers/2019-20/jadhav_swati.jpg',
              score: 'CGPA - 8.87'
            },
            {
              name: 'Mr. Mehetre Aniket Arun',
              image: '/static/images/civil/academicAchievers/2019-20/Mehtre_aniket.jpg',
              score: 'CGPA - 8.45'
            },
            {
              name: 'Mr. Patil Hitesh Supadu',
              image: '/static/images/civil/academicAchievers/2019-20/patil_hitesh.jpg',
              score: 'CGPA - 8.21'
            }
          ]
        },
        {
          year: '2018-19',
          students: [
            {
              name: 'Mr. Sayyed Junaid Sayyed Saleem',
              image: '/static/images/civil/academicAchievers/2018-19/syyad_juned.jpg',
              score: 'CGPA - 8.66'
            },
            {
              name: 'Mr. Mogal Rajanikant Arun',
              image: '/static/images/civil/academicAchievers/2018-19/mogal_rajnikat.jpg',
              score: 'CGPA - 8.52'
            },
            {
              name: 'Miss. Madhwai Shital Suryakant',
              image: '/static/images/civil/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: 'CGPA - 8.48'
            }
          ]
        },
        {
          year: '2017-18',
          students: [
            {
              name: 'Miss. Pardeshi Arti Gokul',
              image: '/static/images/civil/academicAchievers/2017-18/pardeshi_arti.jpg',
              score: 'CGPA - 9.05'
            },
            {
              name: 'Miss. Rode Arti Bharavnath',
              image: '/static/images/civil/academicAchievers/2017-18/rode_arti.jpg',
              score: 'CGPA - 8.89'
            },
            {
              name: 'Mr. Pawar Amol Sanjay',
              image: '/static/images/civil/academicAchievers/2017-18/pawar_amol.jpg',
              score: 'CGPA - 8.73'
            }
          ]
        },
        {
          year: '2016-17',
          students: [
            {
              name: 'Mr. Desale Sachin Laxman',
              image: '/static/images/civil/academicAchievers/2016-17/desale_sachin.jpg',
              score: '80.80%'
            },
            {
              name: 'Mr. Madhvai Tushar Balasaheb',
              image: '/static/images/civil/academicAchievers/2016-17/Madhwai_tushar.jpg',
              score: '80.20%'
            },
            {
              name: 'Mr. Gaikwad Akash Digambar',
              image: '/static/images/civil/academicAchievers/2016-17/gaikwad_akash.jpg',
              score: '75.60%'
            }
          ]
        },
        {
          year: '2015-16',
          students: [
            {
              name: 'Miss. Madhwai Vishal Bhausaheb',
              image: '/static/images/civil/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '76.40%'
            },
            {
              name: 'Miss. Pawar Sarita Mahadu',
              image: '/static/images/civil/academicAchievers/2015-16/pawar_sarita.jpg',
              score: '80.20%'
            },
            {
              name: 'Mr. Joshi Tushar Ashok',
              image: '/static/images/civil/academicAchievers/2015-16/joshi_tushar.jpg',
              score: '73.13%'
            }
          ]
        },]
    }
  },
  methods: {
    getResult(year) {

      const s = this.results.filter(item => {
        return item.year === year
      });

      const result = JSON.parse(JSON.stringify(s))
      // console.log(result[0].students)
      return result[0].students;
    }
  }

}
</script>
<style lang="scss" scoped/>
